// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"410ccd4b","498":"44b994a9","703":"987b232f"}[chunkId] + ".chunk.js";
};